import { Box } from "@mui/material";
import { Button } from "Components/_Shared/Buttons/Button";
import type { FC } from "react";

type Props = {
  readonly onClick: () => Promise<void>;
};

export const RiskInsuranceEmptyState: FC<Props> = ({ onClick }) => {
  return (
    <Box
      sx={{
        height: 60,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Button onClick={onClick}>Doporučit krytá rizika</Button>
    </Box>
  );
};
